<template>
  <div v-if="error" class="login-alert p-3 text-center mb-3">
    <div class="text-primary">{{ error.error }}</div>
    <span v-html="error.msg"></span>
  </div>

  <div v-if="itemSign">
    <div v-if="type == 'ru-token' && itemSign">
      <div class="mb-3 fw-bold">
        Для подписания анкеты лизингополучателя с помощью ЭЦП на носителе
        Рутокен необходимо:
      </div>

      <ul>
        <li>
          Квалифицированная электронная подпись (ЭЦП), выданная ФНС России и
          записанная на Рутокен
        </li>
        <li>
          Браузер: Яндекс.Браузер, Google Chrome, Firefox или Microsoft Edge
        </li>
        <li>
          Криптографический
          <a
            href="https://www.rutoken.ru/products/all/rutoken-plugin/"
            target="_blank"
            >плагин Рутокен</a
          >
        </li>
      </ul>

      <div class="d-flex flex-wrap gap-2">
        <ui-button @click="signFile" :loading="loading" class="btn-base"
          >Подписать</ui-button
        >

        <ui-button @click="close" class="btn-ghost" :disabled="loading"
          >Выбрать другой тип ЭЦП</ui-button
        >
      </div>
    </div>
    <div v-else-if="type == 'crypto-pro' && itemSign">
      <div class="mb-3 fw-bold">
        Для подписания анкеты лизингополучателя с помощью ЭЦП на носителе
        CryptoPro необходимо:
      </div>

      <ul>
        <li>
          Квалифицированная электронная подпись (ЭЦП), выданная ФНС России и
          записанная на носитель CryptoPro
        </li>
        <li>
          Браузер: Яндекс.Браузер, Google Chrome, Firefox или Microsoft Edge
        </li>
        <li>
          Криптографический
          <a
            href="https://www.cryptopro.ru/products/cades/plugin"
            target="_blank"
            >плагин КриптоПро</a
          >
        </li>
      </ul>

      <div class="d-flex flex-wrap gap-2">
        <ui-button @click="signFile" :loading="loading" class="btn-base"
          >Подписать</ui-button
        >

        <ui-button @click="close" class="btn-ghost" :disabled="loading"
          >Выбрать другой тип ЭЦП</ui-button
        >
      </div>
    </div>
    <div v-else-if="type == 'jakarta' && itemSign">
      <div class="mb-3 fw-bold">
        Для подписания анкеты лизингополучателя с помощью ЭЦП на носителе
        JaCarta необходимо:
      </div>

      <ul>
        <li>
          Квалифицированная электронная подпись (ЭЦП), выданная ФНС России и
          записанная на JaCarta
        </li>
        <li>
          Браузер: Яндекс.Браузер, Google Chrome, Firefox или Microsoft Edge
        </li>
        <li>
          <a
            href="https://www.aladdin-rd.ru/catalog/jcwebclient/"
            target="_blank"
            >JC-WebClient</a
          >
          необходим для связи USB-устройств c браузером, он позволяет опознавать
          устройства и работать с ними.
        </li>
      </ul>

      <div class="d-flex flex-wrap gap-2">
        <ui-button @click="signFile" :loading="loading" class="btn-base"
          >Подписать</ui-button
        >

        <ui-button @click="close" class="btn-ghost" :disabled="loading"
          >Выбрать другой тип ЭЦП</ui-button
        >
      </div>
    </div>
  </div>
  <div v-else>
    <div class="mb-3 fw-bold">
      Пожалуйста, вставьте носитель с ЭЦП в USB-порт вашего компьютера и
      выберите тип ЭЦП.
    </div>

    <div class="row">
      <div class="col-12 sign-box">
        <EcpButton
          @auth="getCertificatesObject"
          :loading="loading"
          :loginType="type"
        />

        <Certificates
          v-if="certificatesObject"
          :certificatesObject="certificatesObject"
          @close="() => (certificatesObject = null)"
          @getCertificat="getCertificat"
        />
      </div>
    </div>
  </div>

  <PdfViewer
    v-if="base64File"
    @cancel="
      () => {
        if (!loading) {
          error = null;
          base64File = false;
        }
      }
    "
    @sign="signed"
    :loadingSigned="loading"
    :base64="base64File"
  />
</template>

<script setup>
import { ref } from "vue";

import { useStore } from "vuex";
const store = useStore();

import CryptoECP from "../../lib/crypto";
import EcpButton from "../../component/ecp/Button.vue";
import Certificates from "../../component/ecp/Certificates.vue";

import PdfViewer from "../PdfViewer/index.vue";

import { postApi } from "../../run";

const props = defineProps({
  uid: String,
  inn: {
    type: String,
  },
  phone: {
    type: String,
  },
  getFile: {
    type: Function,
    default: () => false,
  },
  setStatus: {
    type: Function
  },
});

const crypto = ref(null);
const error = ref(null);
const type = ref(null);
const loading = ref(false);

const base64File = ref(null);
const certificatesObject = ref(null);
const itemSign = ref(null);
const fileSign = ref(null);

const getCertificatesObject = (ecpType) => {
  if (!loading.value) {
    error.value = null;
    loading.value = true;
    type.value = ecpType;
    const ecp =
      ecpType === "ru-token"
        ? CryptoECP.ECP_RU_TOKEN
        : ecpType === "crypto-pro"
        ? CryptoECP.ECP_CRYPTO_PRO
        : ecpType === "jakarta"
        ? CryptoECP.ECP_JAKARTA
        : null;

    crypto.value = new CryptoECP(ecp);

    crypto.value.init(
      (ecpInfo) => {
        certificatesObject.value = ecpInfo;
        loading.value = false;
      },
      (initException) => {
        store.commit("main/setAuthException", initException);
        loading.value = false;
        type.value = null;
      }
    );
  }
};

const signFile = async () => {
  loading.value = true;

  await props.getFile().then((d) => {
    if (d.error) {
      loading.value = false;
      error.value = d;
    } else {
      loading.value = false;
      base64File.value = d;
    }
  });
};

const signed = () => {
  loading.value = true;
  crypto.value.signData(
    itemSign.value.id,
    base64File.value,
    (fileSignSuccess) => {
      fileSign.value = fileSignSuccess;
      crypto.value.verifySign(
        base64File.value,
        fileSign.value,
        () => {
          postApi("/signed", {
            UID: props.uid,
            originalFile: base64File.value,
            signedFile: fileSign.value,
            certificate: JSON.stringify(itemSign.value),
          }).then((res) => {
            if (res.status == 1) {
              props.setStatus(res.status);
              base64File.value = false;
            } else if (res.error) {
              error.value = res;
              base64File.value = false;
            }
            loading.value = false;
          });
        },
        (e) => {
          store.commit("main/setAuthException", e);
          loading.value = false;
          base64File.value = false;
        }
      );
    },
    (e) => {
      store.commit("main/setAuthException", e);
      loading.value = false;
      base64File.value = false;
    }
  );
};

const getCertificat = (item) => {
  certificatesObject.value = null;
  error.value = null;
  loading.value = true;
  postApi("/fns", {
    certificate: JSON.stringify(item),
    UID: props.uid,
  }).then((res) => {
    if (res.error) {
      error.value = res;
      loading.value = false;
    } else {
      crypto.value.getCertificate(
        item.id,
        (certificate) => {
          console.log(certificate);

          itemSign.value = item;
          crypto.value.readCertificate(item.id, (readCertificate) => {
            loading.value = false;
          });
        },
        (e) => {
          itemSign.value = null;
          store.commit("main/setAuthException", e);
          loading.value = false;
        }
      );
    }
  });
};

const close = () => {
  error.value = null;
  type.value = null;
  itemSign.value = null;
};
</script>